import { HSLColor } from '../types/color';

export const hue2rgb = (p: number, q: number, t: number) => {
  let tt = t;
  if (tt < 0) tt += 1;
  if (tt > 1) tt -= 1;
  if (tt < 1 / 6) return p + (q - p) * 6 * tt;
  if (tt < 1 / 2) return q;
  if (tt < 2 / 3) return p + (q - p) * (2 / 3 - tt) * 6;
  return p;
};

const getQ = (lightness: number, saturation: number) => (lightness < 0.5
  ? lightness * (1 + saturation)
  : lightness + saturation - lightness * saturation);

const getP = (lightness: number, q: number) => 2 * lightness - q;

const getColor = (name: string, saturation: number, lightness: number, hue: number) => {
  if (saturation === 0) {
    return lightness;
  }

  const q = getQ(lightness, saturation);
  const p = getP(lightness, q);

  switch (name) {
    case 'red':
      return hue2rgb(p, q, hue + 1 / 3);
    case 'blue':
      return hue2rgb(p, q, hue - 1 / 3);
    case 'green':
      return hue2rgb(p, q, hue);
    default:
      return 0;
  }
};

const getRGB = (color: HSLColor) => {
  const hue = Number(color.h) / 360;
  const saturation = Number(color.s) / 100;
  const lightness = Number(color.l) / 100;

  return {
    red: Math.round(getColor('red', saturation, lightness, hue) * 255),
    green: Math.round(getColor('green', saturation, lightness, hue) * 255),
    blue: Math.round(getColor('blue', saturation, lightness, hue) * 255),
  };
};

export const hslToHex = (color: HSLColor) => {
  const rgb = getRGB(color);

  return `#${rgb.red.toString(16)}${rgb.green.toString(16)}${rgb.blue.toString(16)}`;
};

export const hslToRgb = (color: HSLColor) => {
  const rgb = getRGB(color);

  const r = rgb.red;
  const g = rgb.green;
  const b = rgb.blue;

  return { r, g, b };
};
